import TemplateView from '../../../TemplateView'
import {getUserGroupsWithDefault, getTimeZoneGroups} from '../../../entities/selectors'
import {
    getUsersList,
    isNeedToReloadData,
    getNUsersPerPage,
    getNTotalUsers,
    getCurrentPageNum, getSubmittedWordsFilter, getWarningMsgsByUserId, getWorkAssignmentsFilter, getUsersWorkAssignmentsCounters, isLoading,
} from './selectors'
import {loadUsersDataAction, changeCurrentPageNum, changeUsersPerPage, changeWorkAssignmentsFilter} from './actions'
import {connect} from '../../../redux/utils'
import {bindActionCreators} from 'redux'
import {
    getActiveAssignedUserIds, getEditingUserId, getUsersWithoutApprovers, getNewUsersIdSet, getViewerManagementCounters,
    isAllowedToManageAccountSettings
} from "../common/selectors"
import TableHead from './components/TableHead'
import TableBody from './components/TableBody'
import Pager from "../components/Pager";
import ItemsFilter, {createItemObject, createDelimiterObject} from "../components/itemsFilter/ItemsFilter";
import {UserManagementConstants} from "constants"
import messageResource from "../../../messageResource"
import {openEditUserPanel} from "../../../panels/user/editPanel/actions"
import {isBTYEnabled, isTZGEnabled, isUGREnabled, isURAEnabled} from "../../../features/selectors"
import {openWorkAssignmentPanel} from "../workAssignmentPanel/actions"
import ViewerManagementCounters from "./components/ViewerManagementCounters"
import {arrayToSet} from '../../../atUtils'
import _ from 'underscore'
import LoadingMoire from '../../../LoadingMoire'

const WorkAssignmentsFilterValues = UserManagementConstants.WorkAssignmentsFilter

export class WorkAssignmentsTabContainer extends TemplateView {
    constructor({
        loadUsersDataAction = () => {},
        changeCurrentPageNum = () => {},
        changeUsersPerPage = () => {},
        changeWorkAssignmentsFilter = () => {},
        openEditUserPanel = () => {},
        openWorkAssignmentPanel = () => {},
    }) {
        super(null)

        this.state = {
            needToReload: false,
            loading: false,
            users: [],
            userGroups: {},
            timeZoneGroups: {},
            usersWithoutApprovers: [],
            nUsersPerPage: 0,
            nTotalUsers: 0,
            currentPageNum: 1,
            wordsFilter: '',
            warningMsgsByUserId: {},
            workAssignmentsFilter: null,
            editingUserId: null,
            newUsersIdSet: {},
            userGroupsEnabled: false,
            timeZoneGroupsEnabled: false,
            viewerManagementCounters: {},
            usersWorkAssignmentsCounters: {},
            assignedUserIds: null,
            allowedToManageAccountSettings: false,
            isBTYEnabled: false,
            isURAEnabled: false,
        }

        this.actions = {
            loadUsersDataAction,
            changeCurrentPageNum,
            changeUsersPerPage,
            changeWorkAssignmentsFilter,
            openEditUserPanel,
            openWorkAssignmentPanel,
        }

        this.onStatePropertyChanged('needToReload', (needToReload, prevNeedToReload) => {
            if (prevNeedToReload !== needToReload && needToReload === true) {
                this.actions.loadUsersDataAction()
            }
        })

        this.onAnyStatePropertyChanged(['nUsersPerPage', 'nTotalUsers', 'currentPageNum'], () => {
            this.pager.setState({
                totalNumberOfUsers: this.state.nTotalUsers,
                pageNum: this.state.currentPageNum,
                usersPerPage: this.state.nUsersPerPage,
            })
        })

        this.onStateChanged(() => {
            this.tableBody.setState({
                users: this.state.users,
                userGroups: this.state.userGroups,
                timeZoneGroups: this.state.timeZoneGroups,
                usersWithoutApproversSet: arrayToSet(this.state.usersWithoutApprovers),
                wordsFilter: this.state.wordsFilter,
                warningMsgsByUserId: this.state.warningMsgsByUserId,
                editingUserId: this.state.editingUserId,
                newUsersIdSet: this.state.newUsersIdSet,
                userGroupsEnabled: this.state.userGroupsEnabled,
                timeZoneGroupsEnabled: this.state.timeZoneGroupsEnabled,
                viewerManagementCounters: this.state.viewerManagementCounters,
                usersWorkAssignmentsCounters: this.state.usersWorkAssignmentsCounters,
                allowedToManageAccountSettings: this.state.allowedToManageAccountSettings,
                isURAEnabled: this.state.isURAEnabled,
                isBTYEnabled: this.state.isBTYEnabled,
            })
        })

        this.onStatePropertyChanged('workAssignmentsFilter', () => {
            this.workAssignmentsFilter.setState({
                selectedValue: this.state.workAssignmentsFilter
            })
        })

        this.onStatePropertyChanged('viewerManagementCounters', () => {
            this.vieweManagementCounters.setState({
                ...this.state.viewerManagementCounters
            })
        })

        this.onStatePropertyChanged('assignedUserIds', () => {
            this.tableHead.setState({
                assignedUserIds: this.state.assignedUserIds,
            })
        })

        this.onStatePropertyChanged('allowedToManageAccountSettings', () => {
            // for support old styles from (userList.less)
            this.$table.toggleClass('canEditUsers', this.state.allowedToManageAccountSettings)
        })

        this.onAnyStatePropertyChanged(['wordsFilter','users', 'loading'], ({wordsFilter, users, loading}) => {
            const noUsers = users.length === 0
            const filterEmpty = _.isEmpty(wordsFilter)
            this.loadingMoire.toggle(loading)
            this.$noFoundUserMessage.toggle(noUsers && !loading)
            if (noUsers && !loading) {
                this.$noFoundUserMessage.text((!filterEmpty)
                                              ? messageResource.getMessage('userlist.js.users_table_no_users_found')
                                              : messageResource.getMessage('userlist.js.users_table_no_users'))
            }
        })
    }

    templateHtml() {
        return '<div>' +
               '  <table class="userListTable userList_workAssignmentsTable"></table>' +
               '  <div class="noFoundUsersMessage"></div>' +
               '  <div class="workAssignmentsTab_loadingMoirePlaceholder"></div>' +
               '  <div class="pager"></div>' +
               '</div>'
    }

    afterRender() {
        this.$table = this.find('.userListTable')

        this.$noFoundUserMessage = this.find('.noFoundUsersMessage')

        this.workAssignmentsFilter = new ItemsFilter({
            items: this._createWorkAssignmentsFilterItems(),
            defaultValue: WorkAssignmentsFilterValues.ALL,
            onChange: this._handleOnChangeWorkAssignmentsFilter,
            additionalFilterClass: 'greyBackground',
        })

        this.vieweManagementCounters = new ViewerManagementCounters()

        this.tableHead = new TableHead({
            workAssignmentsFilter: this.workAssignmentsFilter,
            viewerManagementCountersComponent: this.vieweManagementCounters,
        }).init(this.$table)
        this.tableBody = new TableBody({
            onNameCellClick: this._handleOnNameCellClick,
            onWorkAssignmentsCellClick: this._handleOnWorkAssignmentsCellClick
        }).init(this.$table)

        this.loadingMoire = new LoadingMoire({
            additionalSpinnerSettings: {
                radius: 17,
                length: 13,
                width: 4
            }
        }).init(this.find('.workAssignmentsTab_loadingMoirePlaceholder'))

        this.pager = new Pager({
            onChangeUserPerPage: this.actions.changeUsersPerPage,
            onChangePageNum: this.actions.changeCurrentPageNum,
        }).init(this.find('.pager'))
    }

    _handleOnChangeWorkAssignmentsFilter = (value) => {
        this.actions.changeWorkAssignmentsFilter(value)
    }

    _handleOnWorkAssignmentsCellClick = (id, level) => {
        this.actions.openWorkAssignmentPanel(id, level)
    }

    _handleOnNameCellClick = (id) => {
        this.actions.openEditUserPanel(id)
    }

    _createWorkAssignmentsFilterItems = () => {
        return [
            createItemObject(WorkAssignmentsFilterValues.ALL, messageResource.getMessage('userlist.work_assignments.filter.all')),
            createDelimiterObject(),
            createItemObject(WorkAssignmentsFilterValues.NO_TASK, messageResource.getMessage('userlist.work_assignments.filter.no_assignments')),
            createDelimiterObject(),
            createItemObject(WorkAssignmentsFilterValues.ALL_SCOPE, messageResource.getMessage('userlist.work_assignments.filter.all_scope'))
        ]
    }
}

export default connect(
    (state) => ({
        users: getUsersList(state),
        userGroups: getUserGroupsWithDefault(state),
        timeZoneGroups: getTimeZoneGroups(state),
        usersWithoutApprovers: getUsersWithoutApprovers(state),
        needToReload: isNeedToReloadData(state),
        currentPageNum: getCurrentPageNum(state),
        nUsersPerPage: getNUsersPerPage(state),
        nTotalUsers: getNTotalUsers(state),
        wordsFilter: getSubmittedWordsFilter(state),
        warningMsgsByUserId: getWarningMsgsByUserId(state),
        workAssignmentsFilter: getWorkAssignmentsFilter(state),
        editingUserId: getEditingUserId(state),
        newUsersIdSet: getNewUsersIdSet(state),
        userGroupsEnabled: isUGREnabled(state),
        timeZoneGroupsEnabled: isTZGEnabled(state),
        viewerManagementCounters: getViewerManagementCounters(state),
        usersWorkAssignmentsCounters: getUsersWorkAssignmentsCounters(state),
        assignedUserIds: getActiveAssignedUserIds(state),
        allowedToManageAccountSettings: isAllowedToManageAccountSettings(state),
        loading: isLoading(state),
        isURAEnabled: isURAEnabled(state),
        isBTYEnabled: isBTYEnabled(state),
    }),
    (dispatch) => ({
        loadUsersDataAction: bindActionCreators(loadUsersDataAction, dispatch),
        changeCurrentPageNum: bindActionCreators(changeCurrentPageNum, dispatch),
        changeUsersPerPage: bindActionCreators(changeUsersPerPage, dispatch),
        changeWorkAssignmentsFilter: bindActionCreators(changeWorkAssignmentsFilter, dispatch),
        openEditUserPanel: bindActionCreators(openEditUserPanel, dispatch),
        openWorkAssignmentPanel: bindActionCreators(openWorkAssignmentPanel, dispatch),
    })
)(WorkAssignmentsTabContainer)



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/workAssignmentsTab/WorkAssignmentsTabContainer.js